import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Statment from '../components/statement';
import dataLoad from '../actions/data-load';
import clearFilter from '../actions/clear-filter';

function mapStateToProps(state) {
  return {
    typeValue: state.customerOrders.orderFilter.typeValue,
    ajaxStatuses: state.ajaxStatuses.dataLoad,
    balance: state.balance,
    user: state.user,
    customer: state.customer,
    payer: state.payerList.payerListing
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    dataLoad,
    clearFilter
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Statment);